import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FooterInfo } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { LINK_PROCESSING } from './models/information.enums';

@Component({
  selector: 'idp-information',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InformationComponent {
  @Input() contentInfo: FooterInfo = {} as FooterInfo;

  processContent(content: string): string {
    return content.replace(
      LINK_PROCESSING.LINK_PATTERN,
      LINK_PROCESSING.LINK_REPLACEMENT
    );
  }
}
